/* eslint-disable max-len */
import * as Constants from './constants';

export const addRequest = (data, pageMode) => ({
  type: Constants.ADD_REQUEST,
  data,
  pageMode,
})
export const addSuccess = result => ({
  type: Constants.ADD_SUCCESS,
  result,
})
export const addError = error => ({
  type: Constants.ADD_ERROR,
  error,
})
export const addClear = () => ({
  type: Constants.ADD_CLEAR
})

export const getRequest = contestId => ({
  type: Constants.GET_REQUEST,
  contestId,
})
export const getSuccess = result => ({
  type: Constants.GET_SUCCESS,
  result,
})
export const getError = error => ({
  type: Constants.GET_ERROR,
  error,
})

export const ownerRequest = () => ({
  type: Constants.OWNER_REQUEST,
})
export const ownerSuccess = result => ({
  type: Constants.OWNER_SUCCESS,
  result,
})
export const ownerError = error => ({
  type: Constants.OWNER_ERROR,
  error,
})

export const testRequest = companyId => ({
  type: Constants.TEST_REQUEST,
  companyId,
})
export const testSuccess = result => ({
  type: Constants.TEST_SUCCESS,
  result,
})
export const testError = error => ({
  type: Constants.TEST_ERROR,
  error,
})

export const locationRequest = location => ({
  type: Constants.LOCATION_REQUEST,
  location,
})
export const locationSuccess = result => ({
  type: Constants.LOCATION_SUCCESS,
  result,
})
export const locationError = error => ({
  type: Constants.LOCATION_ERROR,
  error,
})

export const skillRequest = skill => ({
  type: Constants.SKILL_REQUEST,
  skill,
})
export const skillSuccess = result => ({
  type: Constants.SKILL_SUCCESS,
  result,
})
export const skillError = error => ({
  type: Constants.SKILL_ERROR,
  error,
})

export const locationClear = () => ({
  type: Constants.LOCATION_CLEAR
})

export const skillClear = () => ({
  type: Constants.SKILL_CLEAR
})
